import React from 'react';
import PropTypes from 'prop-types';
import MaxWidthContainer from '../../Global/Containers/MaxWidthContainer';
import MainMenuSubmenuItem from './MainMenuSubmenuItem';

const MainMenuSubMenu = ({ items }) => (
  <div className="main-menu-submenu main-menu__item__submenu bg-white box-shadow-m p-t-5 p-b-3">
    <MaxWidthContainer>
      <ul className="list-row row">
        {items.map(item => (
          <MainMenuSubmenuItem key={item.href} {...item} />
        ))}
      </ul>
    </MaxWidthContainer>
  </div>
);

MainMenuSubMenu.propTypes = {
  items: PropTypes.array.isRequired,
};

export default MainMenuSubMenu;



// WEBPACK FOOTER //
// ./library/app/components/Global/Menus/MainMenuSubmenu.js